export default "__VITE_ASSET__DOD74xTh__"